import Layout from "src/layout/Layout";
import { Route, Routes } from "react-router-dom";
import NotFound from "src/components/notFound/NotFound";
import NotAvailable from "./components/notFound/NotAvailable";
function App() {
  return (
    <div id="APP">
      <Routes>
        <Route index element={<Layout />} />
        <Route path="/view" element={<Layout />} />
        <Route path="/:businessId/:orderId" element={<Layout />} />
        <Route
          path="/businessUuid/:businessUuid/orderUuid/:orderUuid"
          element={<Layout />}
        />
        <Route path="/unavailable" element={<NotAvailable />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
